import { Divider } from '@mantine/core';
import { ProfileFormField } from '../components/ProfileFormField';
import { ProfileFormList } from '../components/ProfileFormList';
import EntityFormProvider from '../EntityFormProvider';

export default function TaxAndAdviceMoments() {
  const benefitDefaultFields = {
    benefit: '',
  };

  const schemeDefaultFields = {
    scheme: '',
  };

  const creditDefaultFields = {
    credit: '',
  };

  return (
    <EntityFormProvider title="Tax and advice moments">
      <ProfileFormField
        entityType="TaxProfile"
        fieldName="requires_capital_gain_tax_management"
        label="Management of CGT required?"
      />
      <ProfileFormField
        entityType="TaxProfile"
        fieldName="has_used_annual_capital_gains_tax"
        label="Annual capital gains tax allowance used"
      />
      <ProfileFormField
        entityType="TaxProfile"
        fieldName="carries_capital_losses_forward"
        label="C/F capital losses?"
      />
      <ProfileFormField
        entityType="TaxProfile"
        fieldName="has_used_annual_isa_allowance"
        label="Annual ISA allowance used"
      />
      <ProfileFormField
        entityType="TaxProfile"
        fieldName="has_used_personal_allowance"
        label="Personal allowance used"
      />
      <ProfileFormField
        entityType="TaxProfile"
        fieldName="has_used_dividend_allowance"
        label="Dividend allowance used"
      />
      <ProfileFormField
        entityType="TaxProfile"
        fieldName="has_used_marriage_allowance"
        label="Marriage allowance used"
      />
      <ProfileFormField entityType="TaxProfile" fieldName="tax_payer_rate" label="Tax payer rate" />
      <ProfileFormField
        entityType="TaxProfile"
        fieldName="us_tax_identification_number"
        label="US tax identification number"
      />

      <Divider />

      <ProfileFormList
        entityType="UtilisedBenefit"
        addButtonLabel="Add benefit"
        defaultFields={benefitDefaultFields}
      >
        {index => (
          <ProfileFormField
            entityType="UtilisedBenefit"
            fieldName="benefit"
            label="Benefit type"
            index={index}
          />
        )}
      </ProfileFormList>

      <Divider />

      <ProfileFormList
        entityType="UtilisedTaxEfficientScheme"
        addButtonLabel="Add tax efficient scheme"
        defaultFields={schemeDefaultFields}
      >
        {index => (
          <ProfileFormField
            entityType="UtilisedTaxEfficientScheme"
            fieldName="scheme"
            label="Scheme type"
            index={index}
          />
        )}
      </ProfileFormList>

      <Divider />

      <ProfileFormList
        entityType="UtilisedTaxCredit"
        addButtonLabel="Add tax credit"
        defaultFields={creditDefaultFields}
      >
        {index => (
          <ProfileFormField
            entityType="UtilisedTaxCredit"
            fieldName="credit"
            label="Tax credit type"
            index={index}
          />
        )}
      </ProfileFormList>
    </EntityFormProvider>
  );
}
